import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSmartModalComponent, NgxSmartModalService } from 'ngx-smart-modal';
import { AbstractBaseComponent } from 'src/app/model/AbstractBaseComponent';
import { SharedService } from '../../../../shared/shared.service';
import { AFunzionalitaService } from '../a-funzionalita.service';

@Component({
  selector: 'app-registrazione-sistema',
  templateUrl: './registrazione-sistema.component.html',
  styleUrls: ['./registrazione-sistema.component.css'],
})
export class RegistrazioneSistemaComponent
  extends AbstractBaseComponent
  implements AfterViewInit, OnInit, OnDestroy {
  registrazioneSistemaAttuale: string;
  registrazioneSistema: boolean;
  submitted = false;

  constructor(
    public ngxSmartModalService: NgxSmartModalService,
    public router: Router,
    private sharedService: SharedService,
    private aFunzionalitaService: AFunzionalitaService
  ) {
    super();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.situazioneRegistrazioneSistemaAttuale();
  }

  onSubmit() {
    this.submitted = true;
  }

  situazioneRegistrazioneSistemaAttuale() {
    this.sharedService.getRegistrazioneSistemaAttuale().subscribe(
      (result: boolean) => {
        if (result) {
          this.registrazioneSistemaAttuale = 'ATTIVA';
        } else {
          this.registrazioneSistemaAttuale = 'DISATTIVA';
        }
        this.registrazioneSistema = result;
      },
      (error) => {
        console.log('Errore getRegistrazioneSistemaAttuale');
      }
    );
  }

  attivaDisattivaRegistrazioneSistema() {
    this.aFunzionalitaService
      .attivaDisattivaRegistrazioneSistema(!this.registrazioneSistema)
      .subscribe(
        (result) => {
          if (result) {
            this.sharedService.openOkModal();
            this.modalSubscribe = this.ngxSmartModalService
              .getModal('okModal')
              .onClose.subscribe((modal: NgxSmartModalComponent) => {
                window.location.reload();
              });
          }
        },
        (error) => {
          console.log('Errore attivaDisattivaRegistrazioneSistema');
        }
      );
  }
}
